import type { Placement } from '@floating-ui/react-dom';
import React from 'react';
import * as styles from './ControlBarPopOver.module.scss';
import PopOverArrow from '../../components/PopOverArrow';
import PopOverPrimitive from '../../components/PopOverPrimitive';
import resizeOnShow from '../../utils/popover/resizeOnShow';

const OFFSET = 14;
const SCREEN_PADDING = 12;

interface ControlBarPopOverProps {
  children: React.ReactNode;
  content: React.ReactNode;
  open: boolean;
  placement: Placement;
  onOpenChange: (open: boolean) => void;
  hide?: boolean;
  preventScreenOverflow?: boolean | { minHeight?: number };
  arrowClassName?: string;
  anchorRef?: React.ComponentProps<typeof PopOverPrimitive>['anchorRef'];
}

const ControlBarPopOver = ({
  content,
  open,
  children,
  placement,
  onOpenChange,
  hide,
  arrowClassName,
  anchorRef,
  preventScreenOverflow,
}: ControlBarPopOverProps) => {
  return (
    <PopOverPrimitive
      onOpenChange={onOpenChange}
      open={open}
      offset={OFFSET}
      screenPadding={SCREEN_PADDING}
      placement={placement}
      trigger="click"
      autoUpdateAnimationFrame
      noFlip
      hideWhenReferenceHidden
      anchorRef={anchorRef}
      getAdditionalMiddleware={
        preventScreenOverflow
          ? (options) => [
              resizeOnShow({
                padding: options.padding,
                minHeight:
                  typeof preventScreenOverflow === 'object'
                    ? preventScreenOverflow.minHeight
                    : undefined,
              }),
            ]
          : undefined
      }
    >
      <PopOverPrimitive.Trigger asChild>{children}</PopOverPrimitive.Trigger>

      {!hide && (
        <PopOverPrimitive.Floating className={styles.floatingContainer}>
          <PopOverPrimitive.Content className={styles.inner}>
            {content}
          </PopOverPrimitive.Content>

          <PopOverArrow className={arrowClassName} />
        </PopOverPrimitive.Floating>
      )}
    </PopOverPrimitive>
  );
};

ControlBarPopOver.Anchor = PopOverPrimitive.Anchor;

export default ControlBarPopOver;
